export const TYPES_LOADING_ERROR = "Failed to load the list of space types.";
